interface ButtonrPops {
  onConfirm: () => void;
  backgroundColor?: string;
  boxShadowColor?: string;
  message?: string;
  height?: number;
  style?: Record<string, any>;
  className?: string;
}

export default function AppButton({onConfirm, height = 46, backgroundColor = '#0094EF', boxShadowColor = '#0070D6', message = '확인', style, className  }: ButtonrPops) {
  return (
    <button
        onClick={onConfirm}
        className={`w-full py-2 text-white font-bold transition-colors rounded-[25px] border-b-[5px] text-[18px] ${className}`} 
        style={{backgroundColor: backgroundColor, borderBottomColor: boxShadowColor, ...style }}
      >
    {message}
    </button>
  );
}

      